/**
 * @author Harshitha.k
 * @description 
 */

import { Tree, Checkbox } from 'antd';
import React, { useEffect, useState } from 'react';
import { DownOutlined } from '@ant-design/icons';

const { TreeNode } = Tree;

const HierarchyModal = (props) => {
  const [checkedArray, setCheckedArray] = useState(props.checkedArray || []);
  const [treeData, setTreeData] = useState(props.treeData || []);
  // const [expandedKeys, setExpandedKeys] = useState([]);
  // const [autoExpandParent, setAutoExpandParent] = useState(true);
  const { handleDropdownChange, translationCache } = props;

  useEffect(() => {
    setCheckedArray(props.checkedArray);
    setTreeData(props.treeData);
  }, [props.checkedArray, props.treeData]);

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  // const onExpand = (expandedKeys) => {
  //   setExpandedKeys(expandedKeys);
  //   setAutoExpandParent(false);
  // };

  // const onCheck = (checkedKeys, info) => {
  //   setCheckedArray(checkedKeys);
  //   handleDropdownChange(checkedKeys, info.checkedNodes);
  // };

  const getTextOnChange = (itemData) => {
    const { AliasCode } = itemData;
    let updatedCheckedArray = [...checkedArray];
    
    if (updatedCheckedArray.includes(AliasCode)) {
      // If already checked, remove it
      updatedCheckedArray = updatedCheckedArray.filter((item) => item !== AliasCode);
    } else {
      // If not checked, add it
      updatedCheckedArray.push(AliasCode);
    }

    setCheckedArray(updatedCheckedArray);
    handleDropdownChange(updatedCheckedArray);
  };

  const renderTreeNodes = (data) => {
    return (
      data &&
      Array.isArray(data) &&
      data.map((item) => {
        if (item.children && item.children.length > 0) {
          return (
            <TreeNode
              title={
                <div>
                  {` ${item.key ? `${translation(item.key)} ` : ''} ${
                    item.title ? `(${translation(item.title)})` : ''
                  }`}
                </div>
              }
              key={item.key}
              dataRef={item}
            >
              {renderTreeNodes(item.children)}
            </TreeNode>
          );
        }
        return (
          <TreeNode
            key={item.key}
            title={
              <div>
                <Checkbox
                  key={item.key}
                  onClick={() => {
                    getTextOnChange(item);
                  }}
                  checked={checkedArray.includes(item.AliasCode)}
                  value={item.AliasCode}
                />
                {` ${item.AliasCode ? `${translation(item.AliasCode)} ` : ''} ${
                  item.Name ? `(${translation(item.Name)})` : ''
                }`}
              </div>
            }
            dataRef={item}
          />
        );
      })
    );
  };

  return (
    <div
      style={{
        width: '100%',
        flex: '35%',
        overflowY: 'auto',
        height: window.innerHeight - 250
      }}
    >
      {/* {Key === 'Interval' ? (
        <Tree
          style={{ color: 'white', backgroundColor: '#1a3652' }}
          showLine
          checkedKeys={checkedArray}
          defaultExpandAll={true}
          switcherIcon={<DownOutlined />}
        >
          {renderTreeNodes(treeData)}
        </Tree>
      ) : ( */}
        <Tree
          className="hierarchyTree"
          style={{ color: 'white', backgroundColor: '#1a3652' }}
          checkedKeys={checkedArray}
          defaultExpandAll={true}
          showLine
          switcherIcon={<DownOutlined />}
        >
          {renderTreeNodes(treeData)}
        </Tree>
      {/* // )} */}
    </div>
  );
};

export default HierarchyModal;